import * as types from "./types";

const mutations = {
  [types.SET_RECIPE_FINISH_MY_DESIGN](state, { recipe }) {
    state.recipe = recipe ;
  },
  [types.SET_LOADING_FINISH_MY_DESIGN](state, { isLoadingFinishMyDesign }) {
    state.isLoadingFinishMyDesign = isLoadingFinishMyDesign ;
  },
  
};

export default mutations;